module.exports = __webpack_public_path__ + "static/img/undraw_organize_photos_d5nr.18186f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/undraw_organize_photos_d5nr.png
// module id = jNSp
// module chunks = 3